"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _form = _interopRequireDefault(require("./form.js"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var AppDefs = window.cccisd.appDefs;
var ProfileUpdateForm = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function ProfileUpdateForm() {
    var _this;
    _classCallCheck(this, ProfileUpdateForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProfileUpdateForm, [].concat(args));
    _defineProperty(_this, "state", {
      loading: true,
      pawn: {},
      fields: [],
      initialValues: {},
      fieldDefs: [],
      isUsernameEmail: false
    });
    _defineProperty(_this, "componentWillMount", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, includePasswordFields, includePawnFields, includeUserFields, includeNotificationFields, pawnHash, pawnId, response, fields, fieldDefs, initialValues, responseUser, emailLabel, usernameLabel, role, showTheseProfileDataFields, roleDef, roleData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, includePasswordFields = _this$props.includePasswordFields, includePawnFields = _this$props.includePawnFields, includeUserFields = _this$props.includeUserFields, includeNotificationFields = _this$props.includeNotificationFields, pawnHash = _this$props.pawnHash, pawnId = _this$props.pawnId;
            _context.next = 3;
            return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.pawn.show', {
              pawnId: pawnId,
              pawnHash: pawnHash
            }));
          case 3:
            response = _context.sent;
            if (response.data.status !== 'success') {
              _this.setState({
                loading: false
              });
              console.error(response.data.errors);
            }
            fields = [];
            fieldDefs = [];
            initialValues = {};
            responseUser = response.data.data.user || null;
            if (responseUser !== null && includeUserFields) {
              emailLabel = 'Email';
              if (responseUser.isUsernameEmail) {
                _this.setState({
                  isUsernameEmail: true
                });
                emailLabel = 'Email (will also update Username)';
              } else {
                fields.push('username');
                initialValues.username = responseUser.username;
                fieldDefs.push({
                  handle: 'username',
                  label: 'Username',
                  data_type: 'string',
                  disabled: true
                });
              }
              fields.push('first_name');
              fields.push('last_name');
              fields.push('email');
              fields.push('phone');
              initialValues.first_name = responseUser.first_name ? responseUser.first_name : '';
              initialValues.last_name = responseUser.last_name ? responseUser.last_name : '';
              initialValues.email = responseUser.email ? responseUser.email : '';
              initialValues.phone = responseUser.phone ? responseUser.phone : '';
              fieldDefs.push({
                handle: 'first_name',
                label: 'First Name',
                data_type: 'string',
                disabled: responseUser.auth_type === 'ldap' ? true : false
              });
              fieldDefs.push({
                handle: 'last_name',
                label: 'Last Name',
                data_type: 'string',
                disabled: responseUser.auth_type === 'ldap' ? true : false
              });
              fieldDefs.push({
                handle: 'email',
                label: emailLabel,
                data_type: 'string',
                extras: {
                  length: 128
                },
                disabled: responseUser.auth_type === 'ldap' ? true : false
              });
              fieldDefs.push({
                handle: 'phone',
                label: 'Phone',
                data_type: 'string'
              });
            }
            if (responseUser !== null && responseUser.auth_type !== 'ldap' && includePasswordFields) {
              if (!fields.includes('username')) {
                usernameLabel = responseUser.isUsernameEmail ? 'Username / Email' : 'Username';
                fields.push('username');
                initialValues.username = responseUser.username;
                fieldDefs.push({
                  handle: 'username',
                  label: usernameLabel,
                  data_type: 'string',
                  autoComplete: 'username',
                  disabled: true
                });
              }
              fields.push('oldPassword');
              fields.push('password');
              fields.push('repeatPassword');
              initialValues.oldPassword = '';
              initialValues.password = '';
              initialValues.repeatPassword = '';
              fieldDefs.push({
                handle: 'oldPassword',
                label: 'Current Password',
                data_type: 'password',
                autoComplete: 'current-password'
              });
              fieldDefs.push({
                handle: 'password',
                label: 'New Password',
                data_type: 'password',
                autoComplete: 'new-password'
              });
              fieldDefs.push({
                handle: 'repeatPassword',
                label: 'Re-enter New Password',
                data_type: 'password',
                autoComplete: 'new-password'
              });
            }

            // if the props showTheseProfileDataFields is included
            // then show those fields for the specified role for updating
            // otherwise, do not show any pawn data fields for updating profile
            role = Fortress.user.acting.role.handle;
            showTheseProfileDataFields = _this.props.showTheseProfileDataFields && _this.props.showTheseProfileDataFields[role] ? _this.props.showTheseProfileDataFields[role] : [];
            roleDef = AppDefs.pawn.roles.filter(function (item) {
              return item.handle === response.data.data.role.handle;
            });
            if (roleDef.length > 0) {
              roleDef = roleDef[0];
              if (Object.prototype.hasOwnProperty.call(roleDef, 'editableFields')) {
                showTheseProfileDataFields = roleDef.editableFields;
              }
            }
            if (includePawnFields) {
              roleData = response.data.data.role_data;
              response.data.data.role.fields.forEach(function (e) {
                if (showTheseProfileDataFields.includes(e.handle)) {
                  fields.push(e.handle);
                  if (e.data_type === 'boolean') {
                    initialValues[e.handle] = roleData[e.handle] ? true : false;
                  } else {
                    initialValues[e.handle] = roleData[e.handle] ? roleData[e.handle] : '';
                  }
                  fieldDefs.push({
                    handle: e.handle,
                    label: e.label,
                    data_type: e.data_type,
                    values: e.values,
                    extras: e.extras
                  });
                }
              });
            }
            if (includeNotificationFields) {
              fields.push('notifications_subscription');
              fields.push('notification_preference');
              initialValues.notifications_subscription = responseUser.notifications_subscription === 1 ? true : false;
              initialValues.notification_preference = responseUser.notification_preference ? responseUser.notification_preference : 'Email';
              fieldDefs.push({
                handle: 'notifications_subscription',
                label: 'Receive Notifications?',
                data_type: 'boolean'
              });
              fieldDefs.push({
                handle: 'notification_preference',
                label: 'Notification Preference',
                data_type: 'enum',
                values: [{
                  name: 'Email',
                  value: 'Email'
                }, {
                  name: 'Text',
                  value: 'Text'
                }]
              });
            }
            _context.next = 19;
            return _this.setState({
              loading: false,
              pawn: response.data.data,
              initialValues: initialValues,
              fields: fields,
              fieldDefs: fieldDefs
            });
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "_onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
        var _this$props2, includeUserFields, onSuccess, pawnId, pawnHash, isUsernameEmail, response, submissionErrors, _i, _Object$keys, key;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, includeUserFields = _this$props2.includeUserFields, onSuccess = _this$props2.onSuccess, pawnId = _this$props2.pawnId, pawnHash = _this$props2.pawnHash;
              isUsernameEmail = _this.state.isUsernameEmail;
              values.pawnId = pawnId;
              values.pawnHash = pawnHash;
              if (isUsernameEmail && includeUserFields && values.email) {
                values.username = values.email;
              } else {
                delete values.username;
              }
              _context2.next = 7;
              return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
                pawn: pawnId
              }), values);
            case 7:
              response = _context2.sent;
              if (!(response.data.status === 'success')) {
                _context2.next = 12;
                break;
              }
              if (onSuccess) {
                onSuccess();
              } else {
                window.location = Boilerplate.url(Fortress.settings.config.after_login_url);
              }
              _context2.next = 20;
              break;
            case 12:
              if (!(response.data.status === 'error')) {
                _context2.next = 19;
                break;
              }
              submissionErrors = {};
              for (_i = 0, _Object$keys = Object.keys(response.data.errors); _i < _Object$keys.length; _i++) {
                key = _Object$keys[_i];
                submissionErrors[key] = Array.isArray(response.data.errors[key]) ? response.data.errors[key].join(', ') : response.data.errors;
              }
              if (isUsernameEmail && submissionErrors.username) {
                submissionErrors.email = submissionErrors.username;
              }
              return _context2.abrupt("return", Promise.reject(submissionErrors));
            case 19:
              console.error(response);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(ProfileUpdateForm, _React$Component);
  return _createClass(ProfileUpdateForm, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        initialValues = _this$state.initialValues,
        loading = _this$state.loading,
        fields = _this$state.fields,
        fieldDefs = _this$state.fieldDefs,
        pawn = _this$state.pawn;
      var _this$props3 = this.props,
        buttonLabel = _this$props3.buttonLabel,
        formName = _this$props3.formName;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: loading
      }, /*#__PURE__*/_react["default"].createElement(_form["default"], {
        onSubmit: this._onSubmit,
        form: formName || 'profileUpdateForm',
        fields: fields,
        initialValues: initialValues,
        fieldDefs: fieldDefs,
        pawn: pawn,
        buttonLabel: buttonLabel
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ProfileUpdateForm, "propTypes", {
  onSuccess: _propTypes["default"].func,
  formName: _propTypes["default"].string,
  pawnId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  pawnHash: _propTypes["default"].string.isRequired,
  includeUserFields: _propTypes["default"].bool,
  includePawnFields: _propTypes["default"].bool,
  includePasswordFields: _propTypes["default"].bool,
  includeNotificationFields: _propTypes["default"].bool,
  buttonLabel: _propTypes["default"].string,
  showTheseProfileDataFields: _propTypes["default"].object // array of data field handles to include in profile update
});
_defineProperty(ProfileUpdateForm, "defaultProps", {
  includeUserFields: true,
  includePawnFields: true,
  includePasswordFields: true,
  includeNotificationFields: true,
  buttonLabel: 'Update',
  showTheseProfileDataFields: {}
});